export class LinkMemberQueryRequestModel {
  body: Body = new Body();
}
export class UpsertRequestModel {
  body: UpBody = new UpBody();
}
export class UpBody {
  ProcessName: string = "DC Community Portal SR Process Wrapper WF";
  DCMethod: string = "QUERY";
  DCLanguage: string = "ENU";
  DCLoginName: string = "";
  DCIncomingHierarchy: UpsertDCIncomingHierarchy = new UpsertDCIncomingHierarchy();
}
export class Body {
  ProcessName: string = "DC Community Portal SR Process Wrapper WF";
  DCMethod: string = "QUERY";
  DCLanguage: string = "ENU";
  DCLoginName: string = "";
  DCIncomingHierarchy: DCIncomingHierarchy = new DCIncomingHierarchy();
}
export class DCIncomingHierarchy {
  MessageId: string = "123456";
  IntObjectName: string = "DC Community Portal SR IO";
  MessageType: string = "Integration Object";
  IntObjectFormat: string = "Siebel Hierarchical";
  ["ListOfDC Community Portal SR IO"]: ListOfDCCommunityPortalSRIO =
    new ListOfDCCommunityPortalSRIO();
}
export class UpsertDCIncomingHierarchy {
  MessageId: string = "123456";
  IntObjectName: string = "DC Community Portal SR IO";
  MessageType: string = "Integration Object";
  IntObjectFormat: string = "Siebel Hierarchical";
  ["ListOfDC Community Portal SR Upsert IO"]: ListOfDCCommunityPortalSRIO =
    new ListOfDCCommunityPortalSRIO();
}

export class ListOfDCCommunityPortalSRIO {
  ["DC Community Portal SR"]: DCCommunityPortalSR = new DCCommunityPortalSR();
}

export class DCCommunityPortalSR {
  "SR Number": string = "";
  "SR Type": string = "";
  "Sub Type": string = "";
  "CSN": string = "";
}
